// extracted by mini-css-extract-plugin
export default {"button":"Tj-z","reviewSort":"Uj-z"};